var _defs, _g, _text, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 411.55 222.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #77a4a4;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #0f3a3d;\n      }\n\n      .cls-5 {\n        fill: #1d6868;\n      }\n\n      .cls-4 {\n        font-family: Aldhabi, Aldhabi;\n        font-size: 39.24px;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-8 {\n        fill: #165354;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 308.99,
    y1: -23.87,
    x2: 223.88,
    y2: 71.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0f3a3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1d6868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#a4b6a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 247.31,
    y1: -47.38,
    x2: 191.52,
    y2: 80.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0f3a3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#1d6868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#a4b6a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 153.61,
    y1: -19.57,
    x2: 153.15,
    y2: 90.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0f3a3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#77a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#baccbe"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m48.39,124.49c0,6.23-3.05,9.34-9.15,9.34H14.98v36.29H0v-100.17h39.23c6.1,0,9.15,3.07,9.15,9.22v45.32Zm-15.11-3.52v-38.15H14.98v38.15h18.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m91.98,132.49h-14.53v-14.79l-11.59.26v52.16h-14.66v-64.65h14.66v2.37c3.03-.55,6.04-1.11,9.02-1.66,3.63-.64,6.66-.96,9.09-.96,5.33,0,8,2.62,8,7.87v19.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m137.42,162.12c0,5.33-2.71,8-8.13,8h-26.24c-5.5,0-8.26-2.67-8.26-8v-48.64c0-5.33,2.75-8,8.26-8h26.24c5.42,0,8.13,2.67,8.13,8v48.64Zm-14.34-4.16v-40.26h-13.89v40.26h13.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m200.78,170.12h-14.4v-49.41c0-2.6.3-6.23.9-10.88l-12.93,51.14h-7.62l-12.99-51.14c.6,4.74.9,8.36.9,10.88v49.41h-14.4v-100.17h14.14l15.75,55.36c.17.6.3,2.11.38,4.54,0-1.07.13-2.58.38-4.54l15.75-55.36h14.14v100.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m245.52,170.12h-14.02v-2.24c-3.33.51-6.66,1.02-9.99,1.54-4.35.64-7.66.96-9.92.96-5.33,0-8-2.62-8-7.87v-23.3c0-5.33,2.75-8,8.26-8h19.78v-14.85h-14.02v9.22h-13.25v-12.1c0-5.33,2.75-8,8.26-8h24.77c5.42,0,8.13,2.67,8.13,8v56.64Zm-13.89-11.65v-17.35h-14.02v17.86l14.02-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m289.24,162.12c0,5.33-2.71,8-8.13,8h-24.64c-5.42,0-8.13-2.67-8.13-8v-13.89h14.02v10.88h12.86v-10.24l-22.47-13.25c-2.94-1.75-4.42-4.1-4.42-7.04v-15.1c0-5.33,2.75-8,8.26-8h24.39c5.42,0,8.13,2.67,8.13,8v12.99h-13.89v-9.99h-12.86v9.34l22.4,13.12c2.99,1.71,4.48,4.1,4.48,7.17v16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m323.35,170.12h-16.26c-5.42,0-8.13-2.67-8.13-8v-44.16h-6.91v-12.48h6.91v-17.54h14.59v17.54h9.41v12.48h-9.41v39.68h9.79v12.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m367.97,162.12c0,5.33-2.75,8-8.26,8h-25.28c-5.5,0-8.26-2.67-8.26-8v-48.64c0-5.33,2.75-8,8.26-8h25.28c5.5,0,8.26,2.67,8.26,8v23.75l-4.03,4.03h-23.75v18.11h13.76v-10.75h14.02v13.5Zm-14.02-30.4v-15.49h-13.76v15.49h13.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m411.55,132.49h-14.53v-14.79l-11.59.26v52.16h-14.66v-64.65h14.66v2.37c3.03-.55,6.04-1.11,9.02-1.66,3.63-.64,6.66-.96,9.09-.96,5.33,0,8,2.62,8,7.87v19.39Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(0 203.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "professional project management\xA0portal"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m285.08,75.27l28.1,1.43S277.4,16.65,227.48,1.64c-6.62-1.99-13.67-2.14-20.4-.58-5.77,1.34-13.39,3.71-21.56,7.84,20.77,3.46,52.32,4.28,99.56,66.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m249.45,74.25c7.15-.21,14.29-.41,21.44-.62-7.24-11.38-21.84-30.64-46.69-43.77-21.5-11.36-39.59-12.28-43.57-12.42-6.47-.23-13.97-.43-22.8,2.85-14.85,5.51-23.02,16.97-26.26,22.19,3.77-2.23,9.27-5.04,16.29-7.13,18.7-5.57,34.5-1.95,42.14-.2,32.38,7.4,52.93,30.98,59.45,39.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m199.37,47.78c6.52,1,8.67,1.9,8.75,1.63.28-.89-21.99-12.43-49.68-11.6-2.84.08-6.88.22-11.2,1.02-25.79,4.76-42.36,31.39-48.87,43.42,5.2-6.22,12.7-13.62,23.01-20.01,12.14-7.52,22.95-10.41,29.11-12.01,2.33-.6,9.45-2.37,18.93-3.26,14.09-1.32,25.15.08,29.93.81Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6ce1751134a2a1eafc0b39a145760ee8.svg";
export { ForwardRef as ReactComponent };